<template lang="pug">
.external-tile-data-overlay
  div(v-for="t in entries", :key="Id(t)")
    AreaLayer(v-for="a in areaLayer(t)", :key="Id(a)", :area="a.area", :color="a.color")
</template>


<script lang="ts">
import Vue from 'vue'
import AreaLayer from "./AreaLayer";
import { store } from '../../store';
import { ExternalTileData } from '.';

export default Vue.extend({
  components: {
    AreaLayer,
  },
  props: {
    module: { required: true },
  },
  computed: {
    entries() {
      return store.modules.externalTileData.entries
    },
  },
  methods: {
    areaLayer(t: ExternalTileData) {
      return [
        { area: t.areas.$any || [], color: [1, 1, 1, 0.125] },
        ...(
          t.show ? [
            { area: t.areas[t.colorParams.filter[0]] || [], color: [1, 0, 0, 0.75] },
            { area: t.areas[t.colorParams.filter[1]] || [], color: [0, 1, 0, 0.75] },
            { area: t.areas[t.colorParams.filter[2]] || [], color: [0, 0, 1, 0.75] },
          ] : []
        )
      ]
    }
  },
})
</script>